(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7648],{

/***/ 30954:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/top100",
      function () {
        return __webpack_require__(76521);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 76521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ top100; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./services/leaderPageText.tsx
var leaderPageText = {
    en: {
        nav: {
            about: "About",
            methodology: "Methodology",
            sectors: "Sectors",
            list: "The List"
        },
        hero: {
            eyebrow: "CNBC Arabia \xb7 Top 100 List \xb7 2026",
            title: "The 100 Business Leaders <accent>Defining</accent> the Region's Economy",
            subtitle: "This list is curated, non-ranked compilation intended to highlight Influence and Impact rather than provide ordered ranking.",
            cta: "Explore the list",
            stats: [
                {
                    value: "100",
                    label: "Leaders"
                },
                {
                    value: "11",
                    label: "Sectors"
                },
                {
                    value: "7",
                    label: "Markets"
                },
                {
                    value: "1",
                    label: "Definitive list"
                }, 
            ],
            marquee: [
                "Banking & Investment",
                "Energy & Utilities",
                "Technology & AI",
                "Real Estate",
                "Healthcare",
                "Retail & Consumer",
                "Logistics & Trade", 
            ]
        },
        about: {
            heading: "About The Top 100 Leaders",
            lead: "Not a Popularity Contest. A Measure of <accent>Impact</accent> — The Leaders Whose Decisions Actually Move the Region’s Markets.",
            description: [
                "Top 100 Leaders is CNBC Arabia's flagship recognition of the people shaping the Middle East's economic story.",
                "It spans boardrooms of the region's largest institutions, founders building next-generation companies, and policymakers drawing the map.",
                "Nominations are reviewed by editors and independent advisors against a published framework focused on measurable performance.", 
            ],
            metrics: [
                {
                    value: "100",
                    label: "Leaders recognised"
                },
                {
                    value: "11",
                    label: "Sectors covered"
                },
                {
                    value: "7",
                    label: "Markets"
                },
                {
                    value: "$3.96 Trillion",
                    label: "Combined market value*"
                }, 
            ]
        },
        methodology: {
            heading: "Methodology",
            lead: "Five Tests. <accent>One</accent> Standard. Every leader is Assessed Against the Same Framework",
            pillars: [
                {
                    title: "Financial performance",
                    description: "Assesses Leader’s ability to generate sustainable financial growth and shareholder value."
                },
                {
                    title: "Market impact",
                    description: "Measurable effect on sector outcomes, shareholder value and the wider economy."
                },
                {
                    title: "Innovation",
                    description: "Building products, models or institutions that did not exist before."
                },
                {
                    title: "Governance",
                    description: "Leadership that endures scrutiny and sets standards for peers."
                },
                {
                    title: "Resilience",
                    description: "Performance sustained through the full economic cycle, not a single year."
                }, 
            ],
            eligibilityText: "Eligible leaders should have led a company headquartered in or with significant operations across the MENA region and have served in their role for at least one year. Companies included in CNBC Arabia Top100 list must have verifiable operational and financial records, regardless of whether they are publicly listed or privately held. Privately held companies qualify provided sufficient public disclosure is available."
        },
        sectors: {
            heading: "Coverage",
            lead: "Eleven Sectors, <accent>One</accent> Economy",
            items: [
                "Banking & Investment",
                "Energy & Utilities",
                "Technology & AI",
                "Real Estate",
                "Healthcare",
                "Retail & Consumer",
                "Logistics & Trade",
                "Telecom & Media",
                "Industrials",
                "Aviation & Transport",
                "Fintech", 
            ]
        },
        list: {
            heading: "The List \xb7 Preview",
            lead: "A First Look at the <accent>2026</accent> List",
            subLead: "",
            all: "All",
            hiddenTitle: "Top 100 list is currently hidden",
            hiddenBody: "The full ranking is locked for launch window and will be accessible after the official release date.",
            popupTitle: "Leader profile"
        },
        languageToggle: {
            english: "English",
            arabic: "Arabic"
        }
    },
    ar: {
        nav: {
            about: "نبذة",
            methodology: "المنهجية",
            sectors: "القطاعات",
            list: "القائمة"
        },
        hero: {
            eyebrow: "لائحة CNBC  عربية لقادة الأعمال - 2026",
            title: "100 من أبرز قادة الأعمال الذين <accent>يشكّلون</accent> ملامح اقتصاد المنطقة",
            subtitle: "تم إعداد هذه القائمة بعناية لكن من دون أي تصنيف أو ترتيب محدد، وتهدف إلى تسليط الضوء على قادة الأعمال الأكثر نفوذاً والأوسع تأثيراً في المنطقة.",
            cta: "استكشف القائمة",
            stats: [
                {
                    value: "100",
                    label: "قيادي"
                },
                {
                    value: "11",
                    label: "قطاعاً"
                },
                {
                    value: "7",
                    label: "أسواق"
                },
                {
                    value: "1",
                    label: "لائحة واحدة!"
                }, 
            ],
            marquee: [
                "البنوك والاستثمار",
                "الطاقة والمرافق",
                "التكنولوجيا والذكاء الاصطناعي",
                "العقارات",
                "الرعاية الصحية",
                "التجزئة والسلع الاستهلاكية",
                "الخدمات اللوجستية والتجارة", 
            ]
        },
        about: {
            heading: "لائحة CNBC  عربية لقادة الأعمال - 2026",
            lead: "لا تُعد <accent>لائحة المئة قيادي</accent> مسابقة لقياس مدى الشعبية أو الحضور الإعلامي، بل مسعىً لإظهار حجم التأثير الحقيقي الذي يمارسه قادة الأعمال ومؤسساتهم في الاقتصاد والأسواق في المنطقة",
            description: [
                "لائحة Top100 من قياديي الأعمال تُجسد إحدى المبادرات الرائدة لـ CNBC عربية للإضاءة على شخصيات تسهم في رسم المشهد الاقتصادي.",
                "وتضم نخبة من قادة المؤسسات الكبرى والمؤسِسين والتنفيذيين الذين يقودون الجيل الجديد من الشركات ويرسمون ملامح مستقبل الأعمال في المنطقة.",
                "وتخضع جميع الترشيحات لإطار تقييم واضح ومعلن يرتكز على الأداء والإنجازات القابلة للقياس.", 
            ],
            metrics: [
                {
                    value: "100",
                    label: "قيادي"
                },
                {
                    value: "11",
                    label: "قطاعاً"
                },
                {
                    value: "7",
                    label: "أسواق"
                },
                {
                    value: "3.96  تريليون $",
                    label: "القيمة السوقية المجمعة*"
                }, 
            ]
        },
        methodology: {
            heading: "منهجية التقييم",
            lead: "خمسة معايير رئيسية. إطار محدد. منهجية واحدة لاختيار قادة الأعمال",
            pillars: [
                {
                    title: "الأداء المالي",
                    description: "مدى قدرة القيادي على تحقيق الأرباح العائدة على المساهمين والنمو "
                },
                {
                    title: "التأثير الاقتصادي",
                    description: "حجم الأثر الملموس الذي يحققه القيادي في قطاعه  وعلى مساهمي شركته  وفي الاقتصاد الكلي"
                },
                {
                    title: "الابتكار",
                    description: "القدرة على تطوير منتجات أو نماذج أعمال أو مؤسسات جديدة قادرة على المنافسة والنمو"
                },
                {
                    title: "الحوكمة",
                    description: "قيادة تتسم بالشفافية والمسؤولية وقادرة على الصمود أمام التدقيق والامتثال"
                },
                {
                    title: "المرونة والاستدامة",
                    description: "تحقيق أداء قوي ومستدام عبر مختلف الدورات الاقتصادية"
                }, 
            ],
            eligibilityText: 'يُشترط في قادة الأعمال المؤهلين للانضمام للائحة "المئة" أن يكونوا قد تولوا قيادة شركة يقع مقرها الرئيسي في المنطقة أو تمارس عمليات رئيسية فيها، وأن يكونوا قد أمضوا ما لا يقل عن عام واحد في مناصبهم القيادية.\nكما يشترط أن تتوفر للشركات ضمن قائمة أفضل 100 قيادي سجلات تشغيلية ومالية موثقة، سواء كانت لشركات مدرجة في الأسواق المالية أو مملوكة للقطاع الخاص.'
        },
        sectors: {
            heading: "القطاعات",
            lead: "أحد عشر قطاعاً \xa0اقتصادٌ واحد",
            items: [
                "البنوك والاستثمار",
                "الطاقة والمرافق",
                "التكنولوجيا والذكاء الاصطناعي",
                "العقارات",
                "الرعاية الصحية",
                "التجزئة والسلع الاستهلاكية",
                "الخدمات اللوجستية والتجارة",
                "الاتصالات والإعلام",
                "الصناعات",
                "الطيران والنقل",
                "التكنولوجيا المالية", 
            ]
        },
        list: {
            heading: "القائمة \xb7 لمحة أولية",
            lead: "نظرة أولى على قائمة <accent>2026</accent>",
            subLead: "",
            all: "الكل",
            hiddenTitle: "قائمة أفضل 100 قائد مخفية حاليًا",
            hiddenBody: "القائمة الكاملة غير متاحة خلال فترة الإطلاق، وستصبح متاحة بعد تاريخ الإصدار الرسمي.",
            popupTitle: "ملف القائد"
        },
        languageToggle: {
            english: "English",
            arabic: "العربية"
        }
    }
};
var LEADER_RELEASE_CONFIG = {
    // Keep true for development preview. Switch to false for production release behavior.
    forceListVisible: true,
    // Optional kill switch for launch-hide override in development.
    forceHiddenWindow: false,
    launchDate: {
        monthIndex: 6,
        day: 6
    },
    releaseDate: {
        monthIndex: 6,
        day: 15
    }
};
var createReleaseDate = function(now, monthIndex, day) {
    return new Date(now.getFullYear(), monthIndex, day, 0, 0, 0, 0);
};
var getLeadersLaunchDate = function() {
    var now = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new Date();
    return createReleaseDate(now, LEADER_RELEASE_CONFIG.launchDate.monthIndex, LEADER_RELEASE_CONFIG.launchDate.day);
};
var getLeadersReleaseDate = function() {
    var now = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new Date();
    return createReleaseDate(now, LEADER_RELEASE_CONFIG.releaseDate.monthIndex, LEADER_RELEASE_CONFIG.releaseDate.day);
};
var isLeadersListHiddenBySchedule = function() {
    var now = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new Date();
    if (LEADER_RELEASE_CONFIG.forceHiddenWindow) {
        return true;
    }
    var launchDate = getLeadersLaunchDate(now);
    var releaseDate = getLeadersReleaseDate(now);
    return now >= launchDate && now < releaseDate;
};
var shouldShowLeadersList = function() {
    var now = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new Date();
    if (LEADER_RELEASE_CONFIG.forceListVisible) {
        return true;
    }
    var releaseDate = getLeadersReleaseDate(now);
    return now >= releaseDate;
};

// EXTERNAL MODULE: ./services/GetData.ts
var GetData = __webpack_require__(17004);
// EXTERNAL MODULE: ./services/Requests.ts
var Requests = __webpack_require__(19061);
;// CONCATENATED MODULE: ./styles/images/fwtop100/Top100Leaders_Collage_1.png
/* harmony default export */ var Top100Leaders_Collage_1 = ({"src":"/_next/static/media/Top100Leaders_Collage_1.2b2044ef.png","height":1285,"width":1922,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAUVBMVEUqYalPeLdkktBwkcIlXKY8Y5dniLYjVZkzYqRZgMRbhcYTWrQuVpIvWpgNR5EjXax+otpFc7AoYKljjcU/aqQ/f89umM5wodtmj8ZUcZtZf7Grhwj0AAAAGnRSTlP1+vnp/fHW9eHh9eTlzuHE9Nrn7Mr++uDV6PrJaEQAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAwSURBVHicBcGFAQAgDAOwosPd/z+UBNEna3fLCFIxtl6FQSFy/MBIR+BTQ/crhML4JwIBnraNoxYAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./styles/images/fwtop100/Top100Leaders_Collage_2.png
/* harmony default export */ var Top100Leaders_Collage_2 = ({"src":"/_next/static/media/Top100Leaders_Collage_2.20f3ae5e.png","height":1285,"width":1922,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAASFBMVEU+P1kwNU9ZW3N5fJBnZHo9PVRKSlxnYHV0dIVxcYZ8fJBCQFVAP1NJT2ErM1MhJj+NiZw6Ok87Ok9WV2p/iJ44OVRLVnM7R2WWsbkaAAAAGHRSTlP5+/37/Obl5Nbz6eDO++Xh9fX02uHEy+8R0oNUAAAACXBIWXMAAAsSAAALEgHS3X78AAAAMElEQVR4nAXBBwIAEAwEsENpa2///6kEuTbm7Q+8KZYcLST0MdUJAshArUCUYwzvfiBQAWg16UXcAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./pages/top100.tsx

















var collageImages = [
    Top100Leaders_Collage_1,
    Top100Leaders_Collage_2, 
];
var UAE_TIME_ZONE = "Asia/Dubai";
var UAE_OFFSET_HOURS = 4;
var cleanImageValue = function(value) {
    var cleaned = String(value || "").replace(/[\u0000-\u001F\u007F]/g, "").trim();
    // Some payloads come wrapped like ["https://..."] or "https://..."
    cleaned = cleaned.replace(/^\[\s*["']?/, "").replace(/["']?\s*\]$/, "");
    cleaned = cleaned.replace(/^["']+|["']+$/g, "").trim();
    return cleaned;
};
var extractImageUrlCandidate = function(value) {
    if (!value) return "";
    // Try to unwrap serialized payloads like ["https://..."] or "\"https://...\"".
    try {
        var parsed = JSON.parse(value);
        if (Array.isArray(parsed) && parsed.length > 0) {
            return cleanImageValue(String(parsed[0]));
        }
        if (typeof parsed === "string") {
            return cleanImageValue(parsed);
        }
    } catch (e) {
    // fall through to regex extraction
    }
    var match = value.match(/https?:\/\/[^"'\\\]]+/i);
    return cleanImageValue(match ? match[0] : value);
};
var normalizeImageUrl = function(value) {
    var cleaned = cleanImageValue(value);
    if (!cleaned) return "";
    var candidate = extractImageUrlCandidate(cleaned);
    try {
        return new URL(candidate).toString();
    } catch (e1) {
        try {
            return new URL(encodeURI(candidate)).toString();
        } catch (e) {
            return "";
        }
    }
};
var getLeaderImageUrl = function(imageUrl, imagePath) {
    var directUrl = normalizeImageUrl(imageUrl);
    if (directUrl) return directUrl;
    var path = cleanImageValue(imagePath);
    if (!path) return "";
    if (/^https?:\/\//i.test(path)) {
        return normalizeImageUrl(path);
    }
    return normalizeImageUrl("".concat(Requests/* fileUrl.replace */._h.replace(/\/$/, ""), "/").concat(path.replace(/^\//, "")));
};
var normalizeSectorName = function(sector, sectorArabic) {
    var normalizedEn = String(sector || "").trim();
    var normalizedAr = String(sectorArabic || "").trim();
    var enTourismVariants = [
        "Tourism & Hospitality",
        "Tourism and Hospitality",
        "tourism & hospitality",
        "tourism and hospitality", 
    ];
    var arTourismVariants = [
        "السياحة والضيافة"
    ];
    var isTourismSector = enTourismVariants.includes(normalizedEn) || arTourismVariants.includes(normalizedAr);
    if (!isTourismSector) {
        return {
            sector: normalizedEn,
            sectorArabic: normalizedAr
        };
    }
    return {
        sector: "Aviation & Transport",
        sectorArabic: "الطيران والنقل"
    };
};
var dummyLeaders = [
    {
        id: 101,
        name: "HH Sheikh Ahmed bin Saeed Al Maktoum",
        nameArabic: "سمو الشيخ أحمد بن سعيد آل مكتوم",
        position: "Chairman & Chief Executive, Emirates Airline & Group",
        positionArabic: "رئيس مجلس الإدارة والرئيس التنفيذي، طيران الإمارات والمجموعة",
        sector: "Logistics & Trade",
        sectorArabic: "الخدمات اللوجستية والتجارة",
        biography: "HH Sheikh Ahmed bin Saeed Al Maktoum began his aviation career in 1985, when he was appointed President of the Dubai Department of Civil Aviation. In the same year, he became Chairman of the newly founded Emirates and led the airline launch with two leased aircraft serving two destinations from Dubai. Today, he leads the Emirates Group, including dnata. Emirates is the world’s largest international airline, serving 152 destinations across six continents and operating 281 aircraft, including the world’s largest Boeing 777 and Airbus A380 fleets, in addition to recently inducted Airbus A350 aircraft. dnata is one of the world’s largest air services providers, offering ground handling, cargo, travel and flight catering services across six continents and supporting more than 300 airline customers globally. Sheikh Ahmed has played a critical role in strengthening Dubai’s position as a global hub for business, tourism, trade and transport. Through multiple government leadership roles, he has contributed to policies and strategies that advance Dubai’s vision, economy, communities and culture. He also supports many charitable organizations and has received prestigious national and international honors. He holds a bachelor’s degree from the University of Denver, Colorado, USA. The Royal Aeronautical Society recognized his aviation achievements with a fellowship at the 1994 Farnborough Air Show in the UK, and in May 2013 he received an honorary Doctor of Science degree from City University London – Cass Business School.",
        biographyArabic: "بدأ سمو الشيخ أحمد بن سعيد آل مكتوم مسيرته في قطاع الطيران عام 1985 عندما عُيّن رئيسًا لدائرة الطيران المدني في دبي. وفي العام نفسه تولّى رئاسة مجلس إدارة طيران الإمارات عند تأسيسها، وقاد انطلاقتها بطائرتين مستأجرتين إلى وجهتين فقط من دبي. ويقود اليوم مجموعة الإمارات التي تضم dnata. تُعد طيران الإمارات أكبر ناقل دولي في العالم، وتخدم 152 وجهة عبر ست قارات، بأسطول يضم 281 طائرة، بما في ذلك أكبر أسطول عالمي من طائرات بوينغ 777 وإيرباص A380، إضافة إلى طائرات إيرباص A350 المنضمة حديثًا. وتُعد dnata من أكبر مزودي الخدمات الجوية عالميًا، حيث تقدم خدمات المناولة الأرضية والشحن والسفر والتموين الجوي عبر ست قارات، وتدعم أكثر من 300 شركة طيران حول العالم. وقد أسهم سموه بشكل كبير في ترسيخ مكانة دبي كمركز عالمي للأعمال والسياحة والتجارة والنقل، كما لعب عبر مناصبه الحكومية دورًا مهمًا في صياغة سياسات واستراتيجيات دعمت رؤية دبي واقتصادها ومجتمعها وثقافتها. وهو كذلك راعٍ لعدد من المبادرات الإنسانية والخيرية، وحاصل على أوسمة وتكريمات وطنية ودولية مرموقة. يحمل سموه درجة البكالوريوس من جامعة دنفر في كولورادو بالولايات المتحدة، كما منحته الجمعية الملكية للطيران زمالة خلال معرض فارنبورو للطيران عام 1994 في المملكة المتحدة، ونال في مايو 2013 درجة الدكتوراه الفخرية في العلوم من جامعة سيتي لندن – كلية كاس للأعمال.",
        order: 1
    },
    {
        id: 1,
        name: "Saeed Al Tayer",
        nameArabic: "سعيد الطاير",
        position: "Vice Chairman & MD, DEWA",
        positionArabic: "نائب الرئيس والعضو المنتدب، ديوا",
        sector: "Energy & Utilities",
        sectorArabic: "الطاقة والمرافق",
        biography: "A long-serving executive known for driving strategic infrastructure and utility transformation in the region.",
        biographyArabic: "قيادي بارز يقود التحول الاستراتيجي في مشاريع البنية التحتية والطاقة والمرافق في المنطقة.",
        order: 2
    },
    {
        id: 2,
        name: "Tareq Al Ashban",
        nameArabic: "طارق الأشبان",
        position: "Chief Executive Officer",
        positionArabic: "الرئيس التنفيذي",
        sector: "Banking & Capital Markets",
        sectorArabic: "البنوك وأسواق رأس المال",
        biography: "Leads growth and governance initiatives across institutional banking and capital market expansion.",
        biographyArabic: "يقود مبادرات النمو والحوكمة في الخدمات المصرفية المؤسسية وتوسّع أسواق رأس المال.",
        order: 3
    },
    {
        id: 3,
        name: "Alison Rehill-Erguven",
        nameArabic: "أليسون ريهيل إرغوفين",
        position: "Chief Executive Officer",
        positionArabic: "الرئيس التنفيذي",
        sector: "Retail & Consumer",
        sectorArabic: "التجزئة والسلع الاستهلاكية",
        biography: "Recognised for consumer growth strategy, category innovation and market-wide talent development.",
        biographyArabic: "معروفة باستراتيجية نمو المستهلك والابتكار في الفئات وتطوير المواهب على مستوى السوق.",
        order: 4
    },
    {
        id: 4,
        name: "Ahmad Aldebasi",
        nameArabic: "أحمد الدباسي",
        position: "General Manager",
        positionArabic: "مدير عام",
        sector: "Real Estate",
        sectorArabic: "العقارات",
        biography: "Drives high-impact real estate investments and long-term value creation through disciplined execution.",
        biographyArabic: "يقود استثمارات عقارية عالية الأثر ويعزز خلق القيمة طويلة الأمد عبر تنفيذ منضبط.",
        order: 5
    },
    {
        id: 5,
        name: "Fahad Al Hassawi",
        nameArabic: "فهد الحساوي",
        position: "Chief Executive Officer",
        positionArabic: "الرئيس التنفيذي",
        sector: "Telecom & Media",
        sectorArabic: "الاتصالات والإعلام",
        biography: "Steers digital transformation, customer innovation and resilient connectivity programs.",
        biographyArabic: "يقود التحول الرقمي وابتكار تجربة العملاء وبرامج الاتصال المرنة.",
        order: 6
    },
    {
        id: 6,
        name: "Khalid Alghafli",
        nameArabic: "خالد الغافلي",
        position: "President",
        positionArabic: "الرئيس",
        sector: "Logistics & Trade",
        sectorArabic: "الخدمات اللوجستية والتجارة",
        biography: "Focused on network efficiency, cross-border trade and supply-chain modernization.",
        biographyArabic: "يركز على كفاءة الشبكات والتجارة العابرة للحدود وتحديث سلاسل الإمداد.",
        order: 7
    }, 
];
var sectorKeys = [
    "banking",
    "energy",
    "ai",
    "real-estate",
    "health",
    "retail",
    "logistics",
    "telecom",
    "industrial",
    "tourism",
    "fintech", 
];
var MARQUEE_REPEAT_COUNT = 6;
var PRIORITY_IMAGE_COUNT = 8;
var getTimeLeft = function(targetDate) {
    var distance = targetDate.getTime() - new Date().getTime();
    if (distance <= 0) {
        return {
            days: "00",
            hours: "00",
            minutes: "00",
            seconds: "00"
        };
    }
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor(distance / (1000 * 60 * 60) % 24);
    var minutes = Math.floor(distance / (1000 * 60) % 60);
    var seconds = Math.floor(distance / 1000 % 60);
    return {
        days: String(days).padStart(2, "0"),
        hours: String(hours).padStart(2, "0"),
        minutes: String(minutes).padStart(2, "0"),
        seconds: String(seconds).padStart(2, "0")
    };
};
var getCurrentUaeYear = function() {
    var formatter = new Intl.DateTimeFormat("en-CA", {
        timeZone: UAE_TIME_ZONE,
        year: "numeric"
    });
    return Number.parseInt(formatter.format(new Date()), 10);
};
var parseReleaseDateWithUaeFallback = function(value) {
    var normalized = String(value || "").trim();
    if (!normalized) return null;
    // If backend sends explicit timezone, trust that absolute timestamp.
    if (/[zZ]|[+\-]\d{2}:?\d{2}$/.test(normalized)) {
        var direct = new Date(normalized);
        return Number.isNaN(direct.getTime()) ? null : direct;
    }
    var match = normalized.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T\s](\d{2})(?::(\d{2}))?(?::(\d{2}))?)?$/);
    if (!match) {
        var direct1 = new Date(normalized);
        return Number.isNaN(direct1.getTime()) ? null : direct1;
    }
    var _match = (0,_sliced_to_array/* default */.Z)(match, 7), yearRaw = _match[1], monthRaw = _match[2], dayRaw = _match[3], tmp = _match[4], hourRaw = tmp === void 0 ? "00" : tmp, tmp1 = _match[5], minuteRaw = tmp1 === void 0 ? "00" : tmp1, tmp2 = _match[6], secondRaw = tmp2 === void 0 ? "00" : tmp2;
    var year = Number.parseInt(yearRaw, 10);
    var month = Number.parseInt(monthRaw, 10) - 1;
    var day = Number.parseInt(dayRaw, 10);
    var hour = Number.parseInt(hourRaw, 10);
    var minute = Number.parseInt(minuteRaw, 10);
    var second = Number.parseInt(secondRaw, 10);
    if ([
        year,
        month,
        day,
        hour,
        minute,
        second
    ].some(function(part) {
        return Number.isNaN(part);
    })) {
        return null;
    }
    // Treat timezone-less API datetime as UAE local time.
    return new Date(Date.UTC(year, month, day, hour - UAE_OFFSET_HOURS, minute, second, 0));
};
var getUaeFallbackReleaseDate = function() {
    var uaeYear = getCurrentUaeYear();
    return new Date(Date.UTC(uaeYear, LEADER_RELEASE_CONFIG.releaseDate.monthIndex, LEADER_RELEASE_CONFIG.releaseDate.day, -UAE_OFFSET_HOURS, 0, 0, 0));
};
var renderAccentText = function(text) {
    var chunks = text.split(/(<accent>.*?<\/accent>)/g).filter(Boolean);
    return chunks.map(function(chunk, index) {
        var match = chunk.match(/^<accent>(.*?)<\/accent>$/);
        if (match) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "fwtop100-accent",
                children: match[1]
            }, "accent-".concat(index));
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            children: chunk
        }, "text-".concat(index));
    });
};
var ROLL_REPEATS = 3;
var ROLL_BASE_INDEX = 10;
var ROLL_UNIT_STAGGER_MS = 108;
var ROLL_DIGIT_STAGGER_MS = 32;
var ROLL_BASE_DURATION_MS = 1035;
var ROLL_INTRO_DURATION_MS = 1800;
var ROLL_EASING = "cubic-bezier(0.22, 1, 0.36, 1)";
var ROLL_INTRO_EASING = "linear";
var ROLL_STRIP_DIGITS = Array.from({
    length: ROLL_REPEATS * 10
}, function(_, index) {
    return String(index % 10);
});
var STATIC_REEL_STRIP_DIGITS = Array.from({
    length: 30
}, function(_, index) {
    return String(index % 10);
});
var useIsomorphicLayoutEffect =  true ? react.useLayoutEffect : 0;
var toTwoDigit = function(value) {
    return String(Math.max(0, Number.parseInt(value, 10) || 0)).padStart(2, "0").slice(-2);
};
var useInViewPulse = function() {
    var threshold = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0.35;
    var ref = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(0), pulse = ref1[0], setPulse = ref1[1];
    var hasTriggeredRef = (0,react.useRef)(false);
    (0,react.useEffect)(function() {
        var element = ref.current;
        if (!element) return;
        if (typeof IntersectionObserver === "undefined") {
            if (!hasTriggeredRef.current) {
                hasTriggeredRef.current = true;
                setPulse(function(prev) {
                    return prev + 1;
                });
            }
            return;
        }
        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting && !hasTriggeredRef.current) {
                    hasTriggeredRef.current = true;
                    setPulse(function(prev) {
                        return prev + 1;
                    });
                    observer.disconnect();
                }
            });
        }, {
            threshold: threshold
        });
        observer.observe(element);
        return function() {
            return observer.disconnect();
        };
    }, [
        threshold
    ]);
    return {
        ref: ref,
        pulse: pulse
    };
};
var getRollTiming = function(unitOrder, digitOrder) {
    // Seconds update every 1s, so keep this unit faster to avoid perpetual blur overlap.
    if (unitOrder === 3) {
        return {
            delay: digitOrder * 18,
            duration: 420,
            introDuration: 900
        };
    }
    return {
        delay: unitOrder * ROLL_UNIT_STAGGER_MS + digitOrder * ROLL_DIGIT_STAGGER_MS,
        duration: ROLL_BASE_DURATION_MS,
        introDuration: ROLL_INTRO_DURATION_MS
    };
};
var StaticReelDigit = function(param) {
    var digit = param.digit, order = param.order, trigger = param.trigger;
    var stripRef = (0,react.useRef)(null);
    var currentIndexRef = (0,react.useRef)(19);
    var previousDigitRef = (0,react.useRef)(null);
    var lastTriggerRef = (0,react.useRef)(0);
    var mountedRef = (0,react.useRef)(false);
    var spinTokenRef = (0,react.useRef)(0);
    useIsomorphicLayoutEffect(function() {
        var strip = stripRef.current;
        if (!strip) return;
        var nextDigit = Number.parseInt(digit, 10);
        if (!Number.isFinite(nextDigit)) return;
        var toTranslate = function(index) {
            return "translateY(".concat(-index, "em)");
        };
        var token = ++spinTokenRef.current;
        var delay = order * 44;
        var duration = mountedRef.current ? 860 : 1200;
        var shouldReplay = lastTriggerRef.current !== trigger;
        lastTriggerRef.current = trigger;
        if (mountedRef.current && previousDigitRef.current === nextDigit && !shouldReplay) {
            return;
        }
        if (!mountedRef.current || shouldReplay) {
            mountedRef.current = true;
            strip.style.transition = "none";
            strip.style.transform = toTranslate(19);
            currentIndexRef.current = 19;
            previousDigitRef.current = 9;
            void strip.offsetHeight;
        }
        var fromIndex = currentIndexRef.current;
        var toIndex = 10 + nextDigit;
        while(toIndex >= fromIndex)toIndex -= 10;
        strip.classList.add("fwtop100-reel-digit-strip--spinning");
        strip.style.transition = "transform ".concat(duration, "ms ").concat(ROLL_EASING, " ").concat(delay, "ms");
        strip.style.transform = toTranslate(toIndex);
        currentIndexRef.current = toIndex;
        previousDigitRef.current = nextDigit;
        var settleTimeout = window.setTimeout(function() {
            if (spinTokenRef.current !== token) return;
            var settledIndex = 10 + nextDigit;
            currentIndexRef.current = settledIndex;
            strip.classList.remove("fwtop100-reel-digit-strip--spinning");
            strip.style.transition = "none";
            strip.style.transform = toTranslate(settledIndex);
        }, delay + duration + 50);
        return function() {
            window.clearTimeout(settleTimeout);
            strip.classList.remove("fwtop100-reel-digit-strip--spinning");
        };
    }, [
        digit,
        order,
        trigger
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: "fwtop100-reel-digit-window",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            ref: stripRef,
            className: "fwtop100-reel-digit-strip",
            children: STATIC_REEL_STRIP_DIGITS.map(function(value, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "fwtop100-reel-digit-char",
                    children: value
                }, "".concat(value, "-").concat(index));
            })
        })
    });
};
var ReelInlineValue = function(param) {
    var value = param.value, rtl = param.rtl, trigger = param.trigger;
    var renderAnimatedValue = function(input, isRtl) {
        var chars = Array.from(input);
        var digitPositions = chars.map(function(char, index) {
            return /\d/.test(char) ? index : -1;
        }).filter(function(index) {
            return index >= 0;
        });
        var digitCount = digitPositions.length;
        var seenDigits = 0;
        return chars.map(function(char, index) {
            var isDigit = /\d/.test(char);
            if (!isDigit) {
                var staticClasses = [
                    "fwtop100-reel-static-char"
                ];
                if (/\s/.test(char)) staticClasses.push("fwtop100-reel-static-char--space");
                if (/[$€£]/.test(char)) staticClasses.push("fwtop100-reel-static-char--currency");
                if (/[\u0600-\u06FFA-Za-z]/.test(char)) staticClasses.push("fwtop100-reel-static-char--letter");
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: staticClasses.join(" "),
                    "aria-hidden": "true",
                    children: char
                }, "char-".concat(index, "-").concat(char));
            }
            var order = isRtl ? digitCount - 1 - seenDigits : seenDigits;
            seenDigits += 1;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StaticReelDigit, {
                digit: char,
                order: order,
                trigger: trigger
            }, "digit-".concat(index, "-").concat(char));
        });
    };
    var hasArabic = /[\u0600-\u06FF]/.test(value);
    var hasCurrency = /[$€£]/.test(value);
    var hasDigit = /\d/.test(value);
    var shouldUseRtlMixedLayout = rtl && hasArabic && hasCurrency && hasDigit;
    if (shouldUseRtlMixedLayout) {
        var numberPart = (value.match(/\d[\d.,]*/) || [
            ""
        ])[0];
        var currencyPart = (value.match(/[$€£]+/) || [
            ""
        ])[0];
        var textPart = value.replace(numberPart, "").replace(/[$€£]+/g, "").replace(/\s+/g, " ").trim();
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            className: "fwtop100-reel-inline fwtop100-reel-inline--rtl-mixed",
            "aria-label": value,
            children: [
                currencyPart ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "fwtop100-reel-static-char fwtop100-reel-static-char--currency",
                    "aria-hidden": "true",
                    children: currencyPart
                }) : null,
                textPart ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "fwtop100-reel-static-char fwtop100-reel-static-char--letter fwtop100-reel-arabic-segment",
                    dir: "rtl",
                    "aria-hidden": "true",
                    children: textPart
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "fwtop100-reel-inline-number",
                    "aria-hidden": "true",
                    children: renderAnimatedValue(numberPart, false)
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: "fwtop100-reel-inline",
        "aria-label": value,
        children: renderAnimatedValue(value, rtl)
    });
};
var ReelDigit = function(param) {
    var digit = param.digit, unitOrder = param.unitOrder, digitOrder = param.digitOrder;
    var stripRef = (0,react.useRef)(null);
    var currentIndexRef = (0,react.useRef)(ROLL_BASE_INDEX + 9);
    var mountedRef = (0,react.useRef)(false);
    var spinTokenRef = (0,react.useRef)(0);
    useIsomorphicLayoutEffect(function() {
        var ref;
        var strip = stripRef.current;
        if (!strip) return;
        var nextDigit = Number.parseInt(digit, 10) || 0;
        var stepHeight = ((ref = strip.parentElement) === null || ref === void 0 ? void 0 : ref.clientHeight) || 36;
        var toTranslate = function(index) {
            return "translateY(".concat(-index * stepHeight, "px)");
        };
        var ref1 = getRollTiming(unitOrder, digitOrder), delay = ref1.delay, duration = ref1.duration, introDuration = ref1.introDuration;
        var token = ++spinTokenRef.current;
        if (!mountedRef.current) {
            mountedRef.current = true;
            var fromIndex = ROLL_BASE_INDEX + 9;
            var toIndex = ROLL_BASE_INDEX + nextDigit;
            while(toIndex >= fromIndex)toIndex -= 10;
            strip.style.transition = "none";
            strip.style.transform = toTranslate(fromIndex);
            currentIndexRef.current = toIndex;
            void strip.offsetHeight;
            strip.style.transition = "transform ".concat(introDuration, "ms ").concat(ROLL_INTRO_EASING, " ").concat(delay, "ms");
            strip.style.transform = toTranslate(toIndex);
            var settleTimeout = window.setTimeout(function() {
                if (spinTokenRef.current !== token) return;
                var settledIndex = ROLL_BASE_INDEX + nextDigit;
                currentIndexRef.current = settledIndex;
                strip.style.transition = "none";
                strip.style.transform = toTranslate(settledIndex);
            }, delay + introDuration + 50);
            return function() {
                window.clearTimeout(settleTimeout);
                strip.classList.remove("fwtop100-roll-strip--spinning");
            };
        }
        var fromIndex1 = currentIndexRef.current;
        var toIndex1 = ROLL_BASE_INDEX + nextDigit;
        while(toIndex1 >= fromIndex1)toIndex1 -= 10;
        strip.classList.remove("fwtop100-roll-strip--spinning");
        strip.style.transition = "none";
        strip.style.transform = toTranslate(fromIndex1);
        currentIndexRef.current = toIndex1;
        void strip.offsetHeight;
        strip.style.transition = "transform ".concat(duration, "ms ").concat(ROLL_EASING, " ").concat(delay, "ms");
        strip.style.transform = toTranslate(toIndex1);
        var settleTimeout1 = window.setTimeout(function() {
            if (spinTokenRef.current !== token) return;
            var settledIndex = ROLL_BASE_INDEX + nextDigit;
            currentIndexRef.current = settledIndex;
            strip.classList.remove("fwtop100-roll-strip--spinning");
            strip.style.transition = "none";
            strip.style.transform = toTranslate(settledIndex);
        }, delay + duration + 50);
        return function() {
            window.clearTimeout(settleTimeout1);
            strip.classList.remove("fwtop100-roll-strip--spinning");
        };
    }, [
        digit,
        unitOrder,
        digitOrder
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: "fwtop100-roll-char",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            ref: stripRef,
            className: "fwtop100-roll-strip",
            children: ROLL_STRIP_DIGITS.map(function(value, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "fwtop100-roll-number fwtop100-roll-value",
                    children: value
                }, "".concat(value, "-").concat(index));
            })
        })
    });
};
var renderRollDigits = function(value, unit, unitOrder, rtl) {
    var digitsOnly = value.replace(/[^\d]/g, "");
    var isDayUnit = unit === "DAYS" || unit === "يوماً";
    var normalized = isDayUnit ? digitsOnly || "0" : (digitsOnly || "0").slice(-2).padStart(2, "0");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "fwtop100-roll-unit",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "fwtop100-roll-slot",
                "aria-live": "polite",
                children: normalized.split("").map(function(digit, digitIndex) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReelDigit, {
                        digit: digit,
                        unitOrder: unitOrder,
                        digitOrder: rtl ? normalized.length - 1 - digitIndex : digitIndex
                    }, "".concat(unit, "-").concat(digitIndex));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                children: unit
            })
        ]
    }, unit);
};
var FwTop100Page = function() {
    var fallbackReleaseDate = (0,react.useMemo)(function() {
        return getUaeFallbackReleaseDate();
    }, []);
    var ref = (0,react.useState)(fallbackReleaseDate), releaseDate = ref[0], setReleaseDate = ref[1];
    var ref1 = (0,react.useState)("ar"), language = ref1[0], setLanguage = ref1[1];
    var ref2 = (0,react.useState)(dummyLeaders), leaders = ref2[0], setLeaders = ref2[1];
    var ref3 = (0,react.useState)(false), isLeadersLoading = ref3[0], setIsLeadersLoading = ref3[1];
    var ref4 = (0,react.useState)(""), leadersError = ref4[0], setLeadersError = ref4[1];
    var ref5 = (0,react.useState)({}), failedLeaderImages = ref5[0], setFailedLeaderImages = ref5[1];
    var ref6 = (0,react.useState)(false), isPopupImageFailed = ref6[0], setIsPopupImageFailed = ref6[1];
    var ref7 = (0,react.useState)("all"), activeSector = ref7[0], setActiveSector = ref7[1];
    var ref8 = (0,react.useState)(null), selectedLeader = ref8[0], setSelectedLeader = ref8[1];
    var ref9 = (0,react.useState)("unknown"), popupImageFit = ref9[0], setPopupImageFit = ref9[1];
    var ref10 = (0,react.useState)(function() {
        return getTimeLeft(releaseDate);
    }), timeLeft = ref10[0], setTimeLeft = ref10[1];
    var ref11 = (0,react.useState)(Date.now() >= fallbackReleaseDate.getTime()), isListUnlocked = ref11[0], setIsListUnlocked = ref11[1];
    var warmedPopupImageUrlsRef = (0,react.useRef)(new Set());
    var hasFetchedLeadersRef = (0,react.useRef)(false);
    var ref12 = useInViewPulse(0.45), heroStatsRef = ref12.ref, heroStatsPulse = ref12.pulse;
    var ref13 = useInViewPulse(0.35), metricsRef = ref13.ref, metricsPulse = ref13.pulse;
    var ref14 = (0,react.useState)(0), activeCollage = ref14[0], setActiveCollage = ref14[1];
    var content = leaderPageText[language];
    var dayCount = Math.max(0, Number.parseInt(timeLeft.days, 10) || 0);
    var dayDisplay = String(dayCount);
    var isArabic = language === "ar";
    var filterItems = (0,react.useMemo)(function() {
        var sectorSet = new Set(leaders.map(function(leader) {
            var primary = isArabic ? leader.sectorArabic : leader.sector;
            var fallback = isArabic ? leader.sector : leader.sectorArabic;
            return String(primary || fallback || "").trim();
        }).filter(Boolean));
        return [
            "all"
        ].concat((0,_to_consumable_array/* default */.Z)(Array.from(sectorSet)));
    }, [
        leaders,
        isArabic
    ]);
    var filteredLeaders = (0,react.useMemo)(function() {
        if (activeSector === "all") {
            return leaders;
        }
        return leaders.filter(function(leader) {
            var primary = isArabic ? leader.sectorArabic : leader.sector;
            var fallback = isArabic ? leader.sector : leader.sectorArabic;
            return String(primary || fallback || "").trim() === activeSector;
        });
    }, [
        activeSector,
        leaders,
        isArabic
    ]);
    var warmPopupImage = function(url) {
        if (false) {}
        var normalized = String(url || "").trim();
        if (!normalized) return;
        if (warmedPopupImageUrlsRef.current.has(normalized)) return;
        warmedPopupImageUrlsRef.current.add(normalized);
        var img = new window.Image();
        img.decoding = "async";
        img.src = normalized;
        if (typeof img.decode === "function") {
            img.decode().catch(function() {
                return undefined;
            });
        }
    };
    (0,react.useEffect)(function() {
        var timer = setInterval(function() {
            setActiveCollage(function(prev) {
                return (prev + 1) % collageImages.length;
            });
        }, 5000);
        // console.log(Top100LeadersCollage1);
        // console.log(Top100LeadersCollage2);
        return function() {
            return clearInterval(timer);
        };
    }, []);
    (0,react.useEffect)(function() {
        var fetchReleaseDate = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var ref, ref1, result, releaseOn, parsedReleaseDate;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0,GetData/* default */.Z)("".concat(Requests/* requests.leaders */.E7.leaders, "/release-on"), {}, "get", false)
                            ];
                        case 1:
                            result = _state.sent();
                            releaseOn = result === null || result === void 0 ? void 0 : (ref = result.data) === null || ref === void 0 ? void 0 : (ref1 = ref.response) === null || ref1 === void 0 ? void 0 : ref1.releaseOn;
                            parsedReleaseDate = parseReleaseDateWithUaeFallback(releaseOn);
                            if (parsedReleaseDate && !Number.isNaN(parsedReleaseDate.getTime())) {
                                setReleaseDate(parsedReleaseDate);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchReleaseDate() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchReleaseDate();
    }, []);
    (0,react.useEffect)(function() {
        if (!isListUnlocked) {
            return;
        }
        if (hasFetchedLeadersRef.current) {
            return;
        }
        var fetchLeaders = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var ref, ref1, result, ref2, leadersResponse, mappedLeaders;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setIsLeadersLoading(true);
                            setLeadersError("");
                            return [
                                4,
                                (0,GetData/* default */.Z)("".concat(Requests/* requests.leaders */.E7.leaders, "/getAll"), {
                                    limit: 100,
                                    pageNo: 1
                                }, "get", false)
                            ];
                        case 1:
                            result = _state.sent();
                            if (result === null || result === void 0 ? void 0 : result.error) {
                                ;
                                setLeadersError((result === null || result === void 0 ? void 0 : (ref2 = result.error) === null || ref2 === void 0 ? void 0 : ref2.message) || "Failed to fetch leaders.");
                                setIsLeadersLoading(false);
                                return [
                                    2
                                ];
                            }
                            leadersResponse = result === null || result === void 0 ? void 0 : (ref = result.data) === null || ref === void 0 ? void 0 : (ref1 = ref.response) === null || ref1 === void 0 ? void 0 : ref1.leaders;
                            if (!Array.isArray(leadersResponse)) {
                                setLeadersError("Invalid leaders response.");
                                setIsLeadersLoading(false);
                                return [
                                    2
                                ];
                            }
                            mappedLeaders = leadersResponse.map(function(leader) {
                                var ref;
                                var normalizedSector = normalizeSectorName(leader === null || leader === void 0 ? void 0 : leader.sector, leader === null || leader === void 0 ? void 0 : leader.sectorArabic);
                                return {
                                    id: Number(leader === null || leader === void 0 ? void 0 : leader.id) || 0,
                                    name: (leader === null || leader === void 0 ? void 0 : leader.name) || "",
                                    nameArabic: (leader === null || leader === void 0 ? void 0 : leader.nameArabic) || "",
                                    position: (leader === null || leader === void 0 ? void 0 : leader.position) || "",
                                    positionArabic: (leader === null || leader === void 0 ? void 0 : leader.positionArabic) || "",
                                    company: (leader === null || leader === void 0 ? void 0 : leader.company) || "",
                                    companyArabic: (leader === null || leader === void 0 ? void 0 : leader.companyArabic) || "",
                                    imageUrl: getLeaderImageUrl(leader === null || leader === void 0 ? void 0 : leader.imageUrl, leader === null || leader === void 0 ? void 0 : (ref = leader.image) === null || ref === void 0 ? void 0 : ref.path),
                                    sector: normalizedSector.sector,
                                    sectorArabic: normalizedSector.sectorArabic,
                                    biography: (leader === null || leader === void 0 ? void 0 : leader.biography) || "",
                                    biographyArabic: (leader === null || leader === void 0 ? void 0 : leader.biographyArabic) || "",
                                    order: Number(leader === null || leader === void 0 ? void 0 : leader.order) || 0
                                };
                            });
                            mappedLeaders.sort(function(a, b) {
                                return a.order - b.order;
                            });
                            setLeaders(mappedLeaders);
                            hasFetchedLeadersRef.current = true;
                            setIsLeadersLoading(false);
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchLeaders() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchLeaders();
    }, [
        isListUnlocked
    ]);
    (0,react.useEffect)(function() {
        if (activeSector === "all") return;
        var hasActiveSector = filterItems.includes(activeSector);
        if (!hasActiveSector) {
            setActiveSector("all");
        }
    }, [
        activeSector,
        filterItems
    ]);
    (0,react.useEffect)(function() {
        setIsPopupImageFailed(false);
        setPopupImageFit("unknown");
    }, [
        selectedLeader === null || selectedLeader === void 0 ? void 0 : selectedLeader.id
    ]);
    (0,react.useEffect)(function() {
        setTimeLeft(getTimeLeft(releaseDate));
        // setIsListUnlocked(Date.now() >= releaseDate.getTime());
        setIsListUnlocked(true); // Temporarily unlock the list for testing purposes
        var interval = setInterval(function() {
            setTimeLeft(getTimeLeft(releaseDate));
            // setIsListUnlocked(Date.now() >= releaseDate.getTime());
            setIsListUnlocked(true);
        }, 1000);
        return function() {
            return clearInterval(interval);
        };
    }, [
        releaseDate
    ]);
    var activeRollClock = {
        hours: toTwoDigit(timeLeft.hours),
        minutes: toTwoDigit(timeLeft.minutes),
        seconds: toTwoDigit(timeLeft.seconds)
    };
    var activeDayDisplay = dayDisplay;
    (0,react.useEffect)(function() {
        document.body.classList.add("fwtop100-body");
        console.log(collageImages);
        return function() {
            document.body.classList.remove("fwtop100-body");
        };
    }, []);
    var scrollToSection = function(sectionId) {
        var section = document.getElementById(sectionId);
        if (!section) return;
        section.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: language === "ar" ? "أفضل 100 قائد" : "Top 100 Leaders"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: "fwtop100-page ".concat(language === "ar" ? "fwtop100-page--ar" : "fwtop100-page--en"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                        className: "fwtop100-topbar",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "fwtop100-topbar-inner",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "fwtop100-brand",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/",
                                            "aria-label": "Go to home page",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "fwtop100-logo fwtop100-logo--cnbc"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "fwtop100-brand-divider"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "fwtop100-logo fwtop100-logo--top100"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                                    className: "fwtop100-nav",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            type: "button",
                                            onClick: function() {
                                                return scrollToSection("fwtop100-about");
                                            },
                                            children: content.nav.about
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            type: "button",
                                            onClick: function() {
                                                return scrollToSection("fwtop100-methodology");
                                            },
                                            children: content.nav.methodology
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            type: "button",
                                            onClick: function() {
                                                return scrollToSection("fwtop100-sectors");
                                            },
                                            children: content.nav.sectors
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            type: "button",
                                            onClick: function() {
                                                if (!isListUnlocked) return;
                                                scrollToSection("fwtop100-list");
                                            },
                                            "aria-disabled": !isListUnlocked,
                                            children: content.nav.list
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            type: "button",
                                            children: content.nav.summit
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "fwtop100-language",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            type: "button",
                                            className: language === "en" ? "active" : "",
                                            onClick: function() {
                                                return setLanguage("en");
                                            },
                                            children: content.languageToggle.english
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            type: "button",
                                            className: language === "ar" ? "active" : "",
                                            onClick: function() {
                                                return setLanguage("ar");
                                            },
                                            children: content.languageToggle.arabic
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: "fwtop100-hero",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "fwtop100-container",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "fwtop100-hero-headline ".concat(language === "ar" ? "fwtop100-hero-headline--rtl" : "fwtop100-hero-headline--ltr"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "fwtop100-hero-mark"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "fwtop100-hero-divider"
                                            }),
                                            !isListUnlocked && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "fwtop100-countdown fwtop100-countdown--hero",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "fwtop100-roll-countdown",
                                                    "aria-label": "days hours minutes seconds countdown",
                                                    children: [
                                                        renderRollDigits(activeDayDisplay, language === "ar" ? "يوماً" : "DAYS", 0, language === "ar"),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "fwtop100-roll-separator",
                                                            children: ":"
                                                        }),
                                                        renderRollDigits(activeRollClock.hours, language === "ar" ? "ساعة" : "HRS", 1, language === "ar"),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "fwtop100-roll-separator",
                                                            children: ":"
                                                        }),
                                                        renderRollDigits(activeRollClock.minutes, language === "ar" ? "دقيقة" : "MIN", 2, language === "ar"),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "fwtop100-roll-separator",
                                                            children: ":"
                                                        }),
                                                        renderRollDigits(activeRollClock.seconds, language === "ar" ? "ثانية" : "SEC", 3, language === "ar")
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "fwtop100-eyebrow",
                                        children: content.hero.eyebrow
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        children: renderAccentText(content.hero.title)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "fwtop100-subtitle",
                                        children: content.hero.subtitle
                                    }),
                                    isListUnlocked && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        type: "button",
                                        className: "fwtop100-cta",
                                        onClick: function() {
                                            return scrollToSection("fwtop100-list");
                                        },
                                        children: content.hero.cta
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "fwtop100-stat-grid",
                                        ref: heroStatsRef,
                                        children: content.hero.stats.map(function(item) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "fwtop100-stat-item",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReelInlineValue, {
                                                            value: item.value,
                                                            rtl: language === "ar",
                                                            trigger: heroStatsPulse
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: item.label
                                                    })
                                                ]
                                            }, "".concat(item.label, "-").concat(item.value));
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "fwtop100-marquee",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "fwtop100-marquee-track",
                                    children: Array.from({
                                        length: MARQUEE_REPEAT_COUNT
                                    }, function(_, setIndex) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "fwtop100-marquee-set",
                                            "aria-hidden": setIndex === 0 ? undefined : true,
                                            children: content.hero.marquee.map(function(item) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: item
                                                }, "marquee-".concat(setIndex, "-").concat(item));
                                            })
                                        }, "marquee-set-".concat(setIndex));
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        id: "fwtop100-about",
                        className: "fwtop100-section",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "fwtop100-container",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "fwtop100-label",
                                    children: content.about.heading
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "fwtop100-two-col",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                children: renderAccentText(content.about.lead)
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: content.about.description.map(function(paragraph, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: paragraph
                                                }, "".concat(paragraph, "-").concat(index));
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "fwtop100-metrics",
                                    ref: metricsRef,
                                    children: content.about.metrics.map(function(metric) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "fwtop100-metric-item",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReelInlineValue, {
                                                        value: metric.value,
                                                        rtl: language === "ar",
                                                        trigger: metricsPulse
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: metric.label
                                                })
                                            ]
                                        }, "".concat(metric.label, "-").concat(metric.value));
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        id: "fwtop100-methodology",
                        className: "fwtop100-section",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "fwtop100-container",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "fwtop100-label",
                                    children: content.methodology.heading
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: renderAccentText(content.methodology.lead)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "fwtop100-pillars",
                                    children: content.methodology.pillars.map(function(pillar) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                            className: "fwtop100-pillar",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    children: pillar.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: pillar.description
                                                })
                                            ]
                                        }, pillar.title);
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "fwtop100-methodology-note",
                                    children: content.methodology.eligibilityText
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        id: "fwtop100-sectors",
                        className: "fwtop100-section",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "fwtop100-container",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "fwtop100-label",
                                    children: content.sectors.heading
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: renderAccentText(content.sectors.lead)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "fwtop100-sector-grid",
                                    children: content.sectors.items.map(function(item, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "fwtop100-sector-item",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "fwtop100-sector-icon fwtop100-sector-icon--".concat(sectorKeys[index])
                                                }),
                                                item
                                            ]
                                        }, "".concat(item, "-").concat(index));
                                    })
                                })
                            ]
                        })
                    }),
                    isListUnlocked && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        id: "fwtop100-list",
                        className: "fwtop100-section fwtop100-list-section",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "fwtop100-container",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "fwtop100-list-header",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "fwtop100-list-logo"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "fwtop100-list-copy",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "fwtop100-label",
                                                    children: content.list.heading
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    children: renderAccentText(content.list.lead)
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "fwtop100-list-sublead",
                                                    children: content.list.subLead
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "fwtop100-filter-row",
                                    children: filterItems.map(function(item) {
                                        var label = item === "all" ? content.list.all : item;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            type: "button",
                                            className: activeSector === item ? "active" : "",
                                            onClick: function() {
                                                return setActiveSector(item);
                                            },
                                            children: label
                                        }, item);
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "fwtop100-leader-grid",
                                    children: filteredLeaders.map(function(leader, leaderIndex) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                            type: "button",
                                            className: "fwtop100-leader-card",
                                            onClick: function() {
                                                return setSelectedLeader(leader);
                                            },
                                            onMouseEnter: function() {
                                                return warmPopupImage(leader.imageUrl);
                                            },
                                            onFocus: function() {
                                                return warmPopupImage(leader.imageUrl);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "fwtop100-leader-media",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "fwtop100-leader-avatar",
                                                        children: !!leader.imageUrl && !failedLeaderImages[leader.id] && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            className: "fwtop100-leader-avatar-image",
                                                            src: leader.imageUrl,
                                                            alt: language === "ar" ? leader.nameArabic : leader.name,
                                                            layout: "fill",
                                                            quality: 50,
                                                            sizes: "(max-width: 640px) 110px, (max-width: 1200px) 150px, 150px",
                                                            loading: leaderIndex < PRIORITY_IMAGE_COUNT ? "eager" : "lazy",
                                                            priority: leaderIndex < 4,
                                                            onError: function() {
                                                                setFailedLeaderImages(function(prev) {
                                                                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, leader.id, true));
                                                                });
                                                            }
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "fwtop100-leader-content",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                            children: language === "ar" ? leader.nameArabic : leader.name
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: language === "ar" ? leader.positionArabic || leader.position : leader.position || leader.positionArabic
                                                        }),
                                                        !!String(language === "ar" ? leader.companyArabic || leader.company : leader.company || leader.companyArabic).trim() && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "fwtop100-leader-company-pill",
                                                            children: language === "ar" ? leader.companyArabic || leader.company : leader.company || leader.companyArabic
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, leader.id);
                                    })
                                }),
                                isLeadersLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "fwtop100-list-sublead",
                                    children: language === "ar" ? "جار تحميل القادة..." : "Loading leaders..."
                                }),
                                !!leadersError && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "fwtop100-list-sublead",
                                    children: language === "ar" ? "تعذّر تحميل البيانات. يتم عرض بيانات تجريبية." : "Could not load API data. Showing fallback data."
                                })
                            ]
                        })
                    }),
                    selectedLeader && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "fwtop100-modal-backdrop",
                        onClick: function() {
                            return setSelectedLeader(null);
                        },
                        role: "presentation",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "fwtop100-modal fwtop100-modal--".concat(popupImageFit),
                            onClick: function(event) {
                                return event.stopPropagation();
                            },
                            role: "dialog",
                            "aria-modal": "true",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: "fwtop100-modal-close",
                                    onClick: function() {
                                        return setSelectedLeader(null);
                                    },
                                    children: "\xd7"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "fwtop100-modal-layout",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "fwtop100-modal-media",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "fwtop100-popup-avatar",
                                                children: !!selectedLeader.imageUrl && !isPopupImageFailed && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    className: "fwtop100-popup-avatar-image",
                                                    src: selectedLeader.imageUrl,
                                                    alt: language === "ar" ? selectedLeader.nameArabic : selectedLeader.name,
                                                    layout: "fill",
                                                    quality: 50,
                                                    sizes: "(max-width: 900px) 100vw, 42vw",
                                                    loading: "eager",
                                                    unoptimized: true,
                                                    priority: true,
                                                    onLoadingComplete: function(image) {
                                                        var width = (image === null || image === void 0 ? void 0 : image.naturalWidth) || 0;
                                                        var height = (image === null || image === void 0 ? void 0 : image.naturalHeight) || 0;
                                                        if (!width || !height) {
                                                            setPopupImageFit("unknown");
                                                            return;
                                                        }
                                                        var ratio = width / height;
                                                        if (ratio >= 1.15) {
                                                            setPopupImageFit("landscape");
                                                            return;
                                                        }
                                                        if (ratio <= 0.98) {
                                                            setPopupImageFit("portrait");
                                                            return;
                                                        }
                                                        setPopupImageFit("square");
                                                    },
                                                    onError: function() {
                                                        setIsPopupImageFailed(true);
                                                        setPopupImageFit("unknown");
                                                    }
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "fwtop100-modal-content",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "fwtop100-label",
                                                    children: content.list.popupTitle
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    children: language === "ar" ? selectedLeader.nameArabic : selectedLeader.name
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "fwtop100-modal-role",
                                                    children: language === "ar" ? selectedLeader.positionArabic : selectedLeader.position
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "fwtop100-modal-company",
                                                    children: language === "ar" ? selectedLeader.companyArabic || selectedLeader.company : selectedLeader.company || selectedLeader.companyArabic
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "fwtop100-modal-sector",
                                                    children: language === "ar" ? selectedLeader.sectorArabic : selectedLeader.sector
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "fwtop100-modal-bio",
                                                    children: language === "ar" ? selectedLeader.biographyArabic : selectedLeader.biography
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var top100 = (FwTop100Page);


/***/ }),

/***/ 87394:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _slicedToArray; }
/* harmony export */ });
/* harmony import */ var _array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18770);
/* harmony import */ var _iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33579);
/* harmony import */ var _non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93520);
/* harmony import */ var _unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15459);





function _slicedToArray(arr, i) {
  return (0,_array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(arr) || (0,_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(arr, i) || (0,_unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(arr, i) || (0,_non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(30954); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);